import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    className={
      className
        ? className + " " + (disabled && "disabled")
        : disabled && "disabled"
    }
    onClick={disabled ? null : onClick}
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="13"
      cy="13"
      r="13"
      fill={color ? color : disabled ? "#4D4D4D" : "#1A1A1A"}
    />
    <rect x="8" y="7" width="4" height="12" rx="2" fill="white" />
    <rect x="15" y="7" width="4" height="12" rx="2" fill="white" />
  </svg>
);
